<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.systemLog)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchClient)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.active)}}</md-option>
										<md-option value="2">{{translate(locale.disabled)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="clientList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<!-- <md-table-head>លេខកូដ</md-table-head> -->
								<md-table-head>{{translate(locale.clientName)}}</md-table-head>
								<md-table-head style="min-width: 180px;">{{translate(locale.lastLog)}}</md-table-head>
								<md-table-head>{{translate(locale.totalChannel)}}</md-table-head>
								<md-table-head>{{translate(locale.totalClientLog)}}</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(client, index) in clientList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<!-- <md-table-cell><b>{{client.hash}}</b></md-table-cell> -->
								<md-table-cell><b>{{client.name}}</b><br>#{{client.hash}}</md-table-cell>
								<md-table-cell><b>{{translate(config.datelify(client.last_log))}}</b><br>({{translate(config.getAge(client.last_log))}})</md-table-cell>
								<md-table-cell><b>{{client.total_channel}}</b></md-table-cell>
								<md-table-cell><b>{{client.total_log}}</b></md-table-cell>
								<md-table-cell>
									<span class="late" v-if="client.status == 0">{{translate(locale.disabled)}}</span>
									<span class="green" v-if="client.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<router-link :to="'system_log/detail/' + client.hash">
										<md-button class="md-just-icon md-simple md-primary" v-if="client.status == 1">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.view)}}</md-tooltip>
										</md-button>
									</router-link>
									<!-- <router-link :to="'system_clients/edit/' + client.hash">
										<md-button class="md-just-icon md-simple md-info">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.edit)}}</md-tooltip>
										</md-button>
									</router-link> -->
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="clientList.length == 0 && loaded == true">{{translate(locale.noClient)}}</h5>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" :md-title="translate(locale.deleteQuotation)" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" :md-title="translate(locale.disableQuotation)" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: ""},
				loadMore: false,
				clientList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/log/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
				})
			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/tender/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/tender/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/profile/tender/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Log/View.vue